// @flow

import Model from "app/models/Model";

import GlobalSettingsStore from "app/stores/GlobalSettingsStore";

export default class User extends Model {
    rowid: number;
    id: string;
    name: string;
    email: string;
    username: string;
    profile_image: string;
    is_admin: boolean;
    _theme: ?string;
    autoplay: boolean;
    early_access: boolean;
    requested_early_access: boolean;
    watch_tour: boolean;
    first_card_message: boolean;
    timeline_thumbnails: boolean;
    profile_slug: ?string;

    normalize() {
        this.normalizeBoolean(
            "is_admin",
            "autoplay",
            "requested_early_access",
            "watch_tour",
            "first_card_message",
            "timeline_thumbnails",
        );
    }

    get fullName(): string {
        return (this.first_name + ' ' + this.last_name).trim();
    }

    get firstName(): string {
        return this.first_name;
    }

    get displayName(): string {
        const name = (this.first_name + ' ' + this.last_name).trim();
        return name.length ? this.name : this.username;
    }

    get theme(): string {
        return this._theme || GlobalSettingsStore.defaultTheme;
    }

    set theme(theme: string) {
        this._theme = theme;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/User.js